export const CONTROLLER = {
    METAVERSE_SESSION: 'MetaverseSession',
    APPLICATION_ROLE: 'ApplicationRole',
    DATA_PREVIEW: 'DataPreview',
    MASTER_DATA: 'MasterData',
    FILE_UPLOAD: 'FileUpload',
    CONFIGURATION: 'Configuration',
    ARCHIVE: 'Archive',
    USER: 'User',
    SOURCE: 'Source',
    COMPANYFOOTPRINT: 'CompanyFootprint',
    VIDEO_DETAILS: 'VideoDetails',
    EXPORT: 'Export',
    APPLICATIONROLE: 'ApplicationRole'
};

export const METHOD = {
    CREATE: 'create',
    LIST: 'list',
    DELETE: 'delete?sessionId={?}',
    UPDATE_STATUS: 'update-sessionstatus?status={?}&sessionId={?}',
    ORGANISER_LIST: 'organiser-list',
    EDIT: 'edit',
    USER_LIST: 'user-list',
    USER_ROLE_DELETE: 'delete-user-role"',
    USER_ROLE_ASSIGN: 'assign-user-role',
    USER_ROLE_EDIT: 'edit-user-role',
    ROLE_LIST: 'role-list',
    USER_ROLE_LIST: 'users-roles-list',
    DATA_PREVIEW: {
        CATEGORIES: 'categories',
        CATEGORY_ERROR_DETAILS: 'categoryErrorDetails',
        ALL_ENTITIES: 'allEntities',
        ENTITY_DETAILS: 'entities',
        ERROR_COUNT: 'errorCount',
        INDICATOR: 'indicator',
        ERROR_DETAILS: 'errorDetails',
        CATEGORY: 'category',
        CATEGORY_DETAILS: 'categoryDetails',
        SEARCH: 'search',
        GET_ENTITY_PATH: 'getEntityPath/{$id}',
        GET_SOURCES: 'getSources',
        CLEAR_PREVIEW: 'clearPreview'
    },
    MASTER_DATA: {
        CATEGORIES: 'getCategories',
        ADD_CATEGORY: 'addCategory',
        EDIT_CATEGORY: 'editCategory',
        GET_CATEGORY_INFO: 'categoryInfo',
        ARCHIVE_CATEGORY: 'archiveCategory',
        ENTITY_BY_CATEGORY_DETAILS: 'entitiesByCategoryId',
        ENTITY_BY_HIERARCHY_DETAILS: 'entitiesByHierarchyId',
        ERROR_COUNT: 'errorCount',
        DELETE_INDICATOR: 'Indicator',
        INDICATOR: 'indicator',
        INDICATOR_INFO: 'indicatorInfo',
        EDIT_INDICATOR: 'editIndicator',
        ARCHIVE_INDICATOR: 'archiveIndicator',
        GET_INDICATOR: 'getIndicator',
        ERROR_DETAILS: 'errorDetails',
        CATEGORY: 'category',
        GET_CATEGORY: 'category',
        SUB_CATEGORY: 'SubCategory',
        ADD_SUB_CATEGORY: 'addSubCategory',
        GET_SUBCATEGORY: 'subCategory',
        EDIT_SUBCATEGORY: 'editSubCategory',
        SUBCATEGORY_INFO: 'subCategoryInfo',
        ARCHIVE_SUBCATEGORY: 'archiveSubCategory',
        ARCHIVED_ENTITIES_BY_PARENT: 'getArchivedEntitiesByCategorySubCategpory',
        CATEGORY_DETAILS: 'categoryDetails',
        SEARCH: 'search',
        GET_ENTITY_PATH: 'getEntityPath/{$id}',
        GET_REVIEW_STATUS: 'reviewStatus',
        GET_SOURCES: 'getSources',
        ADD_INDICATOR: 'addIndicator',
        ADD_INDICATOR_UNDER_NEW_SUBCATEGORY: 'addIndicatorUnderNewSubCategory',
        ADD_INDICATOR_UNDER_NEW_CATEGORY: 'addIndicatorUnderNewCategory',
        LINK_INDICATOR: 'linkIndicator',
        GET_DELETE_FEASIBILITY: 'isDeletableEntity',
        EXPORT_DATA: 'export_master_data',

        /**
         * API METHODS for Move Sub Category
         */
        MOVE_SUB_CATEGORY: 'moveSubcategory',
        MOVE_SUB_CATEGORY_UNDER_NEW_CATEGORY: 'moveSubcategoryUnderNewCategory',
        MOVE_SUB_CATEGORY_UNDER_NEW_SUB_CATEGORY: 'moveSubcategoryUnderNewSubcategory',

        /**
         * API Method to check isMovableSubCategory
         */
        IS_MOVABLE_SUB_Category: 'isMovableSubCategory',

        /**
         * API METHODS for Move Indicators
         */
        MOVE_INDICATOR: 'moveIndicator',
        MOVE_INDICATOR_UNDER_NEW_CATEGORY: 'moveIndicatorUnderNewCategory',
        MOVE_INDICATOR_UNDER_NEW_SUB_CATEGORY: 'moveIndicatorUnderNewSubcategory',

        DISCARD_CHANGES: 'clearReview',
        CLONE_ENTITY: 'cloneSubCategory',
        CHECK_INDICATOR_EXISTS: 'isIndicatorExists'
    },
    FILE_UPLOAD: {
        GET_SYNC_LOGS: 'getSyncLogs',
        ADD_SYNC_LOG: 'addSyncLog',
        GET_SYNC_DETAILS: 'getSyncDetails',
        GET_FILE_DETAILS: 'getFileDetails'
    },
    CONFIGURATION: {
        CONFIGURE: 'configure',
        DELETE: 'delete-configure',
        TRENDING_DATA: 'trending-data',
        DELETE_TRENDING_DATA: 'delete-trending-data',
        REORDER_TRENDING_DATA: 'trending-data-reorder',
        REORDER: 'configure-reorder',
        SAVE_CONFIGURATION: 'save-configure',
        SAVE_TRENDING_CONFIGURATION: 'save-trending-data',
        SAVE_WHATS_NEW_VIDEO_OR_IMAGE: 'save-whats-new-videoorimage',
        WHATS_NEW: 'whats-new',
        DELETE_WHATS_NEW: 'delete-whats-new',
        SAVE_WHATS_NEW: 'Save-whats-new-indicators',
        SAVE_WHATS_NEW_LINK: 'save-whats-new-link',
        WHATS_NEW_REORDER: 'whats-new-reorder',
        GET_CATEGORIES: 'getCategoriesforconfig',
        ENTITIES_BY_CATEGORY_ID: 'entitiesByCategoryIdforconfig',
        ENTITIES_BY_HIERARCHY_ID: 'entitiesByHierarchyIdforconfig',
        BLOB_SAS_URL: 'GetConfigBlobSasUrl'
    },
    ARCHIVE: {
        ARCHIVED_ENTITIES: 'getArchivedEntities',
        ARCHIVED_ENTITIES_BY_ID: 'getArchivedEntitiesById',
        GET_ARCHIVE_FEASIBILITY: 'isArchivableEntity',
        DELETE_ARCHIVED_CATEGORY: 'deleteArchivedCategory',
        DELETE_ARCHIVED_SUB_CATEGORY: 'deleteArchivedSubCategory',
        DELETE_ARCHIVED_INDICATOR: 'deleteArchivedIndicator',
        RESTORE_CATEGORY: 'restoreArchivedCategory',
        RESTORE_SUB_CATEGORY: 'restoreArchivedSubCategory',
        RESTORE_INDICATOR: 'restoreArchivedIndicator',
        ARCHIVE_SEARCH: 'search'
    },
    USER: {
        GET_USER_INFO: 'getUserInfo',
        GET_FEATURES_AND_ACTIONS: 'getFeaturesAndActions'
    },
    SOURCE: {
        GET_INDICATOR_SOURCES: 'sources',
        ADD_INDICATOR_SOURCE: 'addSource',
        UPDATE_INDICATOR_SOURCE: 'updateSource',
        DELETE_INDICATOR_SOURCE: 'deleteSource'
    },
    CLONE: {
        GET_CLONE_FEASIBILITY: 'isClonableEntity'
    },
    COMPANYFOOTPRINT: {
        COMPANY_LOCATIONS: 'company-locations',
        COMPANY_INFO: 'company-info',
        UPDATE_COMPANY_INFO: 'update-company-info',
        UPDATE_COMPANY_FOOTPRINT_LOCATION: 'is-ey-presence'
    },
    VIDEO_DETAILS: {
        VIDEO_TYPES: 'videoTypes',
        VIDEO_DETAILS: 'videoDetails',
        SAVE_VIDEO_DETAILS: 'saveVideoDetails',
        UPDATE_VIDEO_DETAILS: 'UpdateVideoDetails',
        DELETE_VIDEO_DETAILS: 'deleteVideoDetails'
    },
    APPLICATIONROLE: {
        ROLE_LIST: 'role-list',
        APPLICATION_FEATURES: 'application-role-features-list',
        CREATE_ROLE: 'create-application-feature-role',
        UPDATE_ROLE: 'edit-application-feature-role',
        DELETE_ROLE: 'delete-application-feature-role',
        USER_ROLE: 'user-role',
        USERS_ROLES_LIST: 'users-roles-list',
        USERS_LIST: 'user-list',
        ASSIGN_USER_ROLE: 'assign-user-role',
        EDIT_USER_ROLE: 'edit-user-role',
        DELETE_USER_ROLE: 'delete-user-role'
    }
};
